import { makeHook } from "../../utils/makeSingleArgHook";
import { getPortfolioPlanFamilyPath, portfolioPlanFamilyPathURL, } from "../request/getPortfolioPlanFamilyPath";
import { ALL_PORTFOLIOS } from "./constants";
export function portfolioPlanFamilyPathKeyMaker(portfolioPlanId) {
    return [
        portfolioPlanFamilyPathURL(ALL_PORTFOLIOS),
        portfolioPlanFamilyPathURL(portfolioPlanId),
    ];
}
const useGetPortfolioPlanFamilyPath = makeHook(getPortfolioPlanFamilyPath, portfolioPlanFamilyPathKeyMaker);
export default useGetPortfolioPlanFamilyPath;
//# sourceMappingURL=useGetPortfolioPlanFamilyPath.js.map